import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { useLocaleText } from "@mui/x-date-pickers/internals";
import { PickersActionBarProps } from "@mui/x-date-pickers/PickersActionBar";
import moment from "moment-timezone";
import React, { useMemo } from "react";

type CustomActionBarProps = PickersActionBarProps & {
  minDate: moment.Moment;
  maxDate: moment.Moment;
  dateRange: number;
  type: "gte" | "lte";
  isAllowTodayDate: boolean;
};

const CustomActionBar = (props: CustomActionBarProps) => {
  const {
    onAccept,
    onClear,
    onCancel,
    onSetToday,
    actions,
    minDate,
    maxDate,
    dateRange,
    type,
    isAllowTodayDate,
    ...other
  } = props;

  const idDisableToday = useMemo(() => {
    if (moment().diff(maxDate, "days") + moment().diff(minDate, "days") === 0) {
      return true;
    }
    if (type === "gte") {
      return (
        moment().diff(maxDate, "days") >= 0 &&
        moment().diff(maxDate, "days") < dateRange
      );
    }
    return (
      moment().diff(minDate, "days") >= 0 &&
      moment().diff(minDate, "days") < dateRange
    );
  }, [minDate, maxDate, type]);

  const handleSetToday = () => {
    if (idDisableToday || isAllowTodayDate) {
      onSetToday();
    }
  };
  const localeText = useLocaleText();

  if (actions == null || actions.length === 0) {
    return null;
  }

  const buttons = actions?.map(actionType => {
    switch (actionType) {
      case "clear":
        return (
          <Button
            id="clearActionButton"
            data-mui-test="clear-action-button"
            onClick={onClear}
            key={actionType}
          >
            {localeText.clearButtonLabel}
          </Button>
        );

      case "cancel":
        return (
          <Button id="cancelButton" onClick={onCancel} key={actionType}>
            {localeText.cancelButtonLabel}
          </Button>
        );

      case "accept":
        return (
          <Button id="acceptButton" onClick={onAccept} key={actionType}>
            {localeText.okButtonLabel}
          </Button>
        );

      case "today":
        return (
          <Button
            id="todayActionButton"
            data-mui-test="today-action-button"
            onClick={handleSetToday}
            key={actionType}
            disabled={!idDisableToday && !isAllowTodayDate}
          >
            {localeText.todayButtonLabel}
          </Button>
        );

      default:
        return null;
    }
  });

  return <DialogActions {...other}>{buttons}</DialogActions>;
};

export default CustomActionBar;
